import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import MarketOrders from "@/pages/market-orders/page";
import LimitOrders from "@/pages/limit-orders/page";
import StopOrders from "@/pages/stop-orders/page";
import StopLimitOrders from "@/pages/stop-limit-orders/page";
import OrderExecution from "@/pages/order-execution/page";
import Glossary from "@/pages/glossary/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "market-orders",
        element: <MarketOrders />,
      },
      {
        path: "limit-orders",
        element: <LimitOrders />,
      },
      {
        path: "stop-orders",
        element: <StopOrders />,
      },
      {
        path: "stop-limit-orders",
        element: <StopLimitOrders />,
      },
      {
        path: "order-execution",
        element: <OrderExecution />,
      },
      {
        path: "glossary",
        element: <Glossary />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;